var React = require('react');

function Vn (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("clipPath",{"id":"a"},React.createElement("path",{"fillOpacity":".7","d":"M-85.3 0h682.6v512H-85.3z"}))),React.createElement("g",{"fillRule":"evenodd","clipPath":"url(#a)","transform":"translate(80) scale(.9375)","key":1},[React.createElement("path",{"fill":"#ec0015","d":"M-128 0h768v512h-768z","key":0}),React.createElement("path",{"fill":"#ff0","d":"M349.6 381L260 314.3l-89 67.3L204 272l-89-67.7 110.1-1 34.2-109.4L294 203l110.1.1-88.5 68.4 33.9 109.6z","key":1})])]);
}

Vn.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Vn;

Vn.default = Vn;
